<template>
  <div class="proddata com-padding-top-50 com-padding-bottom-90">
    <div class="com-content-1340">
      <div class="dn-upper">
        <el-tabs v-model="modelTabs" @tab-click="clickTabs" class="el-tabs1">
          <el-tab-pane
              :label="item.name" :name="item.id"
              v-for="(item, index) in dataTabs" :key="index">
            <div class="dn-list">
              <div class="dp-a1" :class="{'router-link-active':item2.id==currentSwitch}"
                   @click="clickSwitch(item2)"
                   v-for="(item2, index2) in item.child" :key="index2">
                {{ item2.name }}
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="dn-center com-padding-top-50">
        <el-table class="el-table1"
                  :data="dataTable" border stripe :header-cell-style="stateTableHeader">>
          <el-table-column
              prop="tname" label="产品类型" align="center">
          </el-table-column>
          <el-table-column
              prop="name" label="产品名称" align="center">
          </el-table-column>
          <el-table-column
              prop="type" label="型号" align="center">
          </el-table-column>
          <el-table-column
              label="分解图" align="center">
            <template slot-scope="scope">
              <a class="dp-a1" :href="stateimgBaseURL+scope.row.pdfa" target="_blank">
                <i class="el-icon-download"></i>下载
              </a>
            </template>
          </el-table-column>
          <el-table-column
              label="零件一览表" align="center">
            <template slot-scope="scope">
              <a class="dp-a1" :href="stateimgBaseURL+scope.row.pdfb" target="_blank">
                <i class="el-icon-download"></i>下载
              </a>
            </template>
          </el-table-column>
          <el-table-column
              label="使用说明书" align="center">
            <template slot-scope="scope">
              <a class="dp-a1" :href="stateimgBaseURL+scope.row.pdfc" target="_blank">
                <i class="el-icon-download"></i>下载
              </a>
            </template>
          </el-table-column>
          <el-table-column
              label="单页目录" align="center">
            <template slot-scope="scope">
              <a class="dp-a1" :href="stateimgBaseURL+scope.row.pdfd" target="_blank">
                <i class="el-icon-download"></i>下载
              </a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="dn-lower com-padding-top-30">
        <el-pagination
            align="center" background
            :page-size="pageSize" :current-page="currentPage" :total="total"
            @current-change="currentChange" layout="total, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  data() {
    return {
      dataTabs: [],
      dataTable: [],
      currentSwitch: '',
      modelTabs: '',
      pageSize: 0,
      currentPage: 1,
      total: 0,
      dataParams: {
        first_id: '',
        second_id: '',
        type: '',
        name: '',
        page: 1,
      }
    }
  },
  computed: {
    ...mapState(['stateimgBaseURL', 'stateTableHeader'])
  },
  created() {
    this.dataRequestproduct_productClass()
  },
  methods: {
    // GET产品资料分类类型
    dataRequestproduct_productClass() {
      this.$api.user.product_productClass().then(res => {
        res.data.list.map(item => {
          return item.id = item.id.toString()
        })
        this.dataTabs = res.data.list
        this.modelTabs = this.dataParams.first_id = this.dataTabs[0].id
        // if (this.dataTabs[0].child) {
        //   this.dataParams.second_id = this.dataTabs[0].child[0].id
        // }
        this.dataRequestproduct_productInfoList()
      })
    },
    clickSwitch(item2) {
      this.currentSwitch = this.dataParams.second_id = item2.id
      this.dataParams.page = 1
      this.dataRequestproduct_productInfoList()
    },

    currentChange(val) {
      this.dataParams.page = val
      this.dataRequestproduct_productInfoList()
    },
    clickTabs(tab, event) {
      // this.currentSwitch = ''
      this.dataParams.first_id = this.modelTabs
      // if (this.dataTabs[tab.index].child) {
      //   this.dataParams.second_id = this.dataTabs[tab.index].child[0].id
      // } else {
      //   this.dataParams.second_id = ''
      // }
      this.dataRequestproduct_productInfoList()
    },

    // POST产品资料列表
    dataRequestproduct_productInfoList() {
      let params = {
        ...this.dataParams
      }
      this.$api.user.product_productInfoList(params).then(res => {
        this.dataTable = res.data.list.data
        this.total = res.data.list.total
        this.currentPage = res.data.list.current_page
        this.pageSize = res.data.list.per_page
      })
    },

  },
}
</script>

<style scoped lang="scss">
.proddata {
  .dn-upper {
    .el-tabs1 {
      text-align: center;

      ::v-deep .el-tabs__header {
        display: inline-block;
        border: 1px solid $color2;
        border-radius: 30px;
        overflow: hidden;

        .el-tabs__nav-wrap {
          &::after {
            display: none;
          }

          .el-tabs__nav {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .el-tabs__active-bar {
            display: none;
          }

          .el-tabs__item {
            width: 210px;
            padding: 15px 0;
            height: auto;
            line-height: inherit;
            color: #333333;
            font-size: 16px;

            &.is-active {
              background: $color2;
              color: #ffffff;
            }
          }
        }
      }

      .dn-list {
        display: flex;
        align-items: center;
        justify-content: center;

        .dp-a1 {
          width: 150px;
          border-bottom: 4px solid $line1;
          margin: 0 3px;
          color: #222222;
          text-align: center;
          padding: 8px 0;
          font-size: 16px;
          cursor: pointer;

          &.router-link-active {
            border-bottom: 4px solid $color2;
            color: $color2;
          }
        }
      }
    }

  }

  .dn-center {
    .el-table1 {
      .dp-a1 {
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 26px;
          color: $color2;
          margin: 0 5px 0 0;
        }
      }

    }
  }
}

@media screen and (max-width: 768px) {
  .proddata {
    .dn-upper {
      .el-tabs1 {
        ::v-deep .el-tabs__header {
          border-radius: 30*$mobile-conversion;

          .el-tabs__nav-wrap {
            .el-tabs__item {
              width: 210*$mobile-conversion;
              padding: 15*$mobile-conversion 0;
              font-size: 26*$mobile-conversion;
            }
          }
        }

        .dn-list {
          .dp-a1 {
            width: 150*$mobile-conversion;
            margin: 0 6*$mobile-conversion;
            padding: 8*$mobile-conversion 0;
            font-size: 26*$mobile-conversion;
          }
        }
      }
    }

  }

}
</style>
